<template>
  <header class="tt-topbar" :class="{ 'tt-topbar--detail': back }">
    <button v-if="back" class="tt-topbar__back" aria-label="Regresar" @click="$emit('back')">
      <span class="mdi mdi-arrow-left"></span>
    </button>

    <div class="tt-topbar__titles">
      <span class="tt-topbar__title">{{ title }}</span>
      <span v-if="subtitle" class="tt-topbar__subtitle">{{ subtitle }}</span>
    </div>

    <span
      v-if="priority"
      class="tt-topbar__priority"
      :style="{ backgroundColor: priority.color }"
    >{{ priority.label }}</span>
    <div v-else-if="user" class="tt-topbar__avatar" :style="{ backgroundColor: user.avatarColor }">
      <img v-if="user.avatarUrl" :src="avatarSrc(user.avatarUrl)" alt="" />
      <template v-else>{{ initials }}</template>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/services/authStore'
import { avatarSrc } from '@/services/auth'

defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  back: { type: Boolean, default: false },
  priority: { type: Object, default: null }, // { label, color }
})
defineEmits(['back'])

const { state } = useAuthStore()
const user = computed(() => state.user)
const initials = computed(() => {
  const source = user.value?.name || user.value?.email || ''
  return (
    source.split(' ').filter(Boolean).map((s) => s[0]).join('').slice(0, 2).toUpperCase() || '?'
  )
})
</script>

<style scoped>
.tt-topbar {
  display: flex; align-items: center; gap: 12px;
  height: 56px; padding: 0 16px; flex-shrink: 0;
  background: var(--side-panel); border-left: 1px solid var(--border-subtle);
}
.tt-topbar__titles { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.tt-topbar__title { font-family: var(--font-display); font-weight: 700; font-size: 15px; color: #fff; line-height: 1.2; }
.tt-topbar__subtitle { font: 400 11px Inter, sans-serif; color: rgba(255, 255, 255, 0.6); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tt-topbar--detail .tt-topbar__titles { align-items: center; }
.tt-topbar__back {
  width: 36px; height: 36px; margin-left: -8px; flex-shrink: 0;
  background: none; border: none; color: #fff; font-size: 20px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; border-radius: 50%;
}
.tt-topbar__back:active { background: rgba(255, 255, 255, 0.12); }
/* Mismo ancho que el botón de regreso para que el número del ticket quede realmente centrado. */
.tt-topbar--detail .tt-topbar__priority { min-width: 36px; text-align: center; }
.tt-topbar__priority { font: 500 11px Inter, sans-serif; color: #fff; padding: 3px 10px; border-radius: 12px; flex-shrink: 0; }
.tt-topbar__avatar {
  width: 32px; height: 32px; border-radius: 50%; overflow: hidden; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font: 600 11px Inter, sans-serif;
}
.tt-topbar__avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
</style>